import { Layout } from "antd";
import React from "react";
import OrganizerPNav from "./OrganizerPNav";

import { Outlet } from "react-router-dom";
const { Content } = Layout;
const OrganizerPLayout = () => {
  return (
    <Layout>
      <div className="profile-header">
        <div className="layout-width">
          <OrganizerPNav />
        </div>
      </div>
      <Content className="layout-width">
        <Outlet />
      </Content>
      {/* <Footer style={{ backgroundColor: "#2F89FC" }}>
        <HomeFooter />
      </Footer> */}
    </Layout>
  );
};

export default OrganizerPLayout;
